// test2979
(2979 && 0);
